<template>
  <div class="fullHeight">
    <MypageSideMenu :memberDropClose="true"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-reserve mypage-title-icon"
        >
        <table class="table table-striped listTable">
            <thead class="sp_not">
            <tr>
                <th class="text-center width-120" scope="col">プレー日</th>
                <th class="text-center width-120" scope="col">ゴルフ場名</th>
                <th class="text-center min-width-35" scope="col">精算額</th>
                <th class="text-center width-120" scope="col">明細</th>
                <th class="text-center width-120" scope="col">領収</th>
            </tr>
            </thead>
            <tbody>
                <template v-if="results.length === 0">
                    <tr>
                        <td colspan="8" class="text-center">実績がありません。</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="data in results" :key="data.settle_no">
                        <td class="max-width-35 text-center d-flex justify-content-between d-sm-table-cell">
                            <span class="sp_label text-left">プレー日</span>{{ data.play_date }}
                        </td>
                        <td class="max-width-35 text-center d-flex justify-content-between d-sm-table-cell">
                            <span class="sp_label text-left">ゴルフ場名</span>{{ data.golf_name }}
                        </td>
                        <td class="min-width-75 text-center number-text d-flex justify-content-between d-sm-table-cell">
                            <span class="sp_label text-left">精算額</span>{{ data.total_amount | number_format }}
                        </td>
                        <td class="min-width-75 btn-align d-flex justify-content-between d-sm-table-cell">
                            <span class="sp_label">明細</span>
                            <button
                                class="bluebackbutton btn-sm"
                                @click="gotoSpecification(data)"
                            >明&nbsp;細
                            </button>
                        </td>
                        <td class="min-width-75 btn-align d-flex justify-content-between d-sm-table-cell">
                            <span class="sp_label">領収</span>
                            <button
                                class="bluebackbutton btn-sm"
                                @click="gotoReceipt(data)"
                            >領&nbsp;収
                            </button>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <nav v-if="results.length >= 1" aria-label="Page navigation" class="w-100">
            <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item" @click="ClickPagination('Previous')">
                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">前へ</span>
                </li>
                <li class="pagination-center">
                    <span>{{ pagination }} / {{ maxPaginationNotReturnZero }}</span>
                </li>
                <li class="page-item" @click="ClickPagination('Next')">
                    <span class="framebutton Mypagepoint_pagelinkwidth py-1">次へ</span>
                </li>
            </ul>
        </nav>
    </Card>
    <MypageMenuFooter/>
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import { GET_SETTLE_RESULT_LIST } from '../../constants/settles';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card
    },
    data () {
        return {
            // ページタイトル
            page_title: '実績一覧',
            // 現在ログインしているメンバーID
            memberNo: '',
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // 実績情報
            results: [],
            // 表示中のページネーション番号
            pagination: 1,
            // 最大ページネーション数(初期表示)
            maxPagination: 1,
            // 一覧取得の開始値
            beginRow: 0,
            // 一覧の最大表示値
            limitRows: 10,
        };
    },
    created () {
        this.memberNo = this.$store.state.auth.loginMember.member_no;
        this.getResultList();
    },
    computed: {
        maxPaginationNotReturnZero () {
            return this.maxPagination === 0 ? 1 : this.maxPagination;
        }
    },
    methods: {
        /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        ClickPagination: function (mode) {
            // 前へボタン押下時処理
            if (mode === 'Previous') {
                if (this.pagination > 1) {
                    this.pagination--;
                    if (this.display_pagination === 1) {
                        this.beginRow = 0;
                    } else {
                        this.beginRow = this.beginRow - this.limitRows;
                    }
                    this.getResultList();
                } else {
                    return;
                }
            } else {
                // 次へボタン押下時処理
                if (this.pagination < this.maxPagination) {
                    this.beginRow = this.beginRow + this.limitRows;
                    this.pagination++;
                    this.getResultList();
                } else {
                    return;
                }
            }
        },
        /** ----------------------------------------------
         * 実績一覧を取得
         * ---------------------------------------------- */
        getResultList () {
            this.$apollo.query({
                query: GET_SETTLE_RESULT_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    member_no: this.memberNo,
                    limit: this.limitRows,
                    offset: this.beginRow
                }
            }).then(res => {
                this.results = res.data.GetSettleResultList.SettleResultList;
                const totalCount = res.data.GetSettleResultList.count;
                this.maxPagination = Math.ceil(totalCount / this.limitRows);
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
            })
        },
        /** ----------------------------------------------
         * お問い合わせページに遷移
         * ---------------------------------------------- */
        gotoInquiry (data) {
            this.$store.commit("mypage/pushReserveNo", data.reserve_no);
            this.$store.commit("mypage/pushPlanName", data.plan_name);
            this.$store.commit('mypage/useGolfCode', data.golf_code);
            this.$store.commit('mypage/pushPlayDate', data.play_date);
            this.$router.push({ path: '/mypage-reserve-contact' });
        },
        /** ----------------------------------------------
         * 明細書に遷移
         * ---------------------------------------------- */
        gotoSpecification (data) {
            sessionStorage.setItem('MyPage.settleNo', data.settle_no);
            this.$router.push({ path: '/Specification' });
        },
        /** ----------------------------------------------
         * 領収書に遷移
         * ---------------------------------------------- */
        gotoReceipt (data) {
            sessionStorage.setItem('MyPage.settleNo', data.settle_no);
            this.$router.push({ path: '/Receipt' });
        },
    }
}

</script>

<style scoped>
.table td{
    vertical-align: inherit;
    padding: 7px;
}
.yesterday{
    background-color: #dee2e6 !important;
}
.no_yesterday {
    background-color:#ffffff;
}
.bluebackbutton {
    width: 75%;
}
@media screen and (max-width: 896px) {
  .max-width-35{
      max-width: initial;
  }
  .max-width-50{
      max-width: initial;
  }
  .max-width-15{
      max-width: initial;
  }
  .max-width-1{
      max-width: initial;
  }
}
@media screen and (max-width: 575px) {
  .sp_btn {
      font-size: 0.73rem;
  }
  .bluebackbutton {
    width: 25%;
  }
}
</style>
